export const boardTaskDetailTour = {
  key: "boardTaskDetail",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-taskdetail-topmenu"]',
      content: t("Tour_BoardTaskDetail_Title"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-taskdetail-description"]',
      content: t("Tour_BoardTaskDetail_Description"),
      placement: "top",
    },
    {
      target: '[data-tour="board-taskdetail-checklist"]',
      content: t("Tour_BoardTaskDetail_Checklist"),
      placement: "top",
    },
    {
      target: '[data-tour="board-taskdetail-actions"]',
      content: t("Tour_BoardTaskDetail_Actions"),
      placement: "top",
    },
    {
      target: '[data-tour="board-taskdetail-subtasks"]',
      content: t("Tour_BoardTaskDetail_Subtasks"),
      placement: "top",
    },
  ],
};
